<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [labelActionItems]="labelActions$ | async"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-radio-list-complex-base
            [formControl]="control"
            [items]="items"
            [groupName]="groupName ?? controlId"
            [describeLabelId]="describeLabelId"
            [invalid]="isControlInvalid$ | async"
            [inline]="inline"
            [disabledMsg]="disabledMsg"
            [id]="controlId"
        >
        </sh-form-radio-list-complex-base>
    </ng-template>

    <ng-template #simple>
        <sh-form-radio-list-base
            [formControl]="control"
            [items]="items"
            [groupName]="groupName ?? controlId"
            [describeLabelId]="describeLabelId"
            [invalid]="isControlInvalid$ | async"
            [inline]="inline"
            [disabledMsg]="disabledMsg"
            [id]="controlId"
        >
        </sh-form-radio-list-base>
    </ng-template>
</sh-form-group>
